export default __webpack_public_path__ + "static/media/trac_9.3f256282.png";